import { FC } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import MembershipOutletGuard from '../components/MembershipOutletGuard';
import { useAuth } from '../contexts/AuthContext';
import { getMembershipRedirectPath } from '../utils/membershipRedirect';
import Layout from '../components/Layout';
import Auth from '../pages/auth/Auth';
import TwoFA from '../pages/auth/2FA';
import PaymentHistory from '../pages/payments/PaymentHistory';
import Dashboard from '../pages/dashboard';
// import Profile from '../pages/Profile';
// import Business from '../pages/Business';
import ProfileAndBusiness from '../pages/ProfileAndBusiness';
// import Channel from '../pages/Channel';
// import Behavior from '../pages/Behavior';
import Conversations from '../pages/Conversations';
import Chatbox from '../pages/Chatbox';
// import Marketplace from '../pages/marketplace/Marketplace';
// import MyIntegrations from '../pages/marketplace/MyIntegrations';
// import AutomateResponse from '../pages/automatePage/automateResponse';
import NotFound from '../pages/NotFound';
// import KnowledgeGraph from '../pages/KnowledgeGraph';
// import DocumentManager from '../pages/DocumentManager';
import KnowledgeBase from '../pages/KnowledgeBase';
import AidaSettings from '../pages/AidaSettings';
import Membership from '../pages/Membership';
import MembershipRoute from '../components/MembershipRoute';
import DidarSettingRedirect from '../pages/marketplace/DidarSettingRedirect';
import PersonalInfoNew from '../pages/onboarding/PersonalInfoNew';
import SubscriptionNew from '../pages/onboarding/SubscriptionNew';
// import NewAuth from '../pages/auth/NewAuth';

// Component to preserve query parameters when redirecting
const NavigateWithQuery: FC<{ to: string }> = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

const DefaultHomeRedirect: FC = () => {
  const { user } = useAuth();
  return <Navigate to={getMembershipRedirectPath(user?.membership)} replace />;
};

const AppRoutes: FC = () => {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/auth/auth" element={<Auth />} />
      <Route path="/signin/2FA" element={<TwoFA />} />
      <Route path="/auth/signup" element={<NavigateWithQuery to="/auth/auth" />} />
      <Route path="/login" element={<NavigateWithQuery to="/auth/auth" />} />
      <Route path="/signup" element={<NavigateWithQuery to="/auth/auth" />} />

      {/* Onboarding Routes - Only for inactive users */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute requireOnboarding>
            <PersonalInfoNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding/subscription"
        element={
          <ProtectedRoute requireOnboarding>
            <SubscriptionNew />
          </ProtectedRoute>
        }
      />

      {/* Main App Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route element={<MembershipOutletGuard />}>
          <Route index element={<DefaultHomeRedirect />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="aida-settings" element={<AidaSettings />} />
          <Route path="didar-setting" element={<DidarSettingRedirect />} />
          <Route path="payments" element={<PaymentHistory />} />
          {/* <Route path="profile" element={<Profile />} /> */}
          <Route path="profile-and-business" element={<ProfileAndBusiness />} />
          {/* <Route path="business" element={<Business />} /> */}
          {/* <Route path="channel" element={<Channel />} /> */}
          {/* <Route path="behavior" element={<Behavior />} /> */}
          <Route path="conversations" element={<Conversations />} />
          <Route path="chatbox" element={<Chatbox />} />
          <Route
            path="membership"
            element={
              <MembershipRoute>
                <Membership />
              </MembershipRoute>
            }
          />
          {/* <Route path="automate-response" element={<AutomateResponse />} /> */}
          {/* <Route path="marketplace" element={<Marketplace />} /> */}
          {/* <Route path="my-integrations" element={<MyIntegrations />} /> */}
          <Route path="knowledge-base" element={<KnowledgeBase />} />
          {/* <Route path="knowledge"> */}
            {/* <Route path="graph" element={<KnowledgeGraph />} /> */}
            {/* <Route path="documents" elemen/>={<DocumentManager />} /> */}
          {/* </Route> */}
        </Route>
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes; 